import FeatureServices from './FeatureServices';

export default FeatureServices;
